<template>
  <div>
    <breadcrumbs :home="item.name + ': Move to site'"/>

      <v-card flat>
        <v-form v-model="valid" ref="form" :disabled="!edit">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>

            <v-row dense>
              <v-col cols="6" sm="4" lg="3">
                <date-picker v-model="transaction.date" @change="refresh"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" lg="4">
                <v-autocomplete outlined dense label="From site" v-model="transaction.fromSiteId" :items="sites" item-value="id" item-text="name"/>
              </v-col>
              <v-col cols="12" sm="6" lg="4">
                <v-autocomplete outlined dense label="To site" v-model="transaction.toSiteId" :items="sites" item-value="id" item-text="name"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="3" lg="2">
                <decimal-number-input label="Move" v-model="transaction.quantity" :precision="item.precision" prefix="" :suffix="item.trackUnits"
                                      :hint="transactionId ? '' : currentQuantity"/>
              </v-col>
              <v-col cols="6" sm="3" lg="2" v-if="item.lotTracking">
                <v-combobox v-model="transaction.lot" outlined dense label="Lot" :items="currentLots" :rules="[fieldRules.required,fieldRules.maxLength(20)]"/>
              </v-col>
            </v-row>

            <v-row dense >
              <v-col cols="12">
                <v-text-field label="Comments" v-model="transaction.comments" outlined dense :rules="[fieldRules.maxLength(255)]" counter="255"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-divider/>
        <v-card-actions class="px-6">
          <v-switch v-if="transactionId && $store.getters.company.permissions.includes('inventory.write')"
                    v-model="edit" label="Edit" hide-details class="mt-0" :disabled="dirty"/>
          <v-spacer/>
          <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
          <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>

</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'InventoryItemsTransferSite',
  mixins: [confirmLeave],
	props: {
    itemId: {type:String,required:false},
    transactionId: {type:String, required:false}
	},
	data() {
		return {
      edit: false,
      item: {name:'',sites:[]},
      valid:true,
      saving:false,
			transaction: {itemId:this.itemId, date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'), quantity: 0, lot:'', fromSiteId:'',toSiteId:'', comments:''},
      dirty: false
		}
  },
  computed: {
    sites() {
      return this.$store.getters.sites(!this.transactionId);
    },
    currentLots() {
      return this.item.sites.filter(site => site.siteId === this.transaction.fromSiteId).map(site => site.lot);
    },
    currentQuantity() {
      const site = this.item.sites.find(site => site.siteId === this.transaction.fromSiteId && site.lot === this.transaction.lot);
      return site ? this.$number(site.quantity, this.item.precision) : '';
    }
  },
  watch: {
    transaction: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
	async created() {
    if (this.sites.length === 0) {
      this.$store.commit('setError', {message:`There must be multiple sites in order to transfer`,type:'error'})
      this.$nextTick(() => {
        this.dirty = false;
        this.$router.back();
      });
      return;
    }

    this.transaction.fromSiteId = this.sites[0].id;
    this.transaction.toSiteId = this.sites[1].id;
    if (this.transactionId) {
      const results = await this.$apiCall(`query InventoryItemsTransferSite($id:ID!) {
                                                itemTransferSite(id:$id) {
                                                  itemId,date,fromSiteId,toSiteId,quantity,comments,lot
                                                }
                                              }`,
                                          {id:this.transactionId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.transaction = results.data.itemTransferSite;
      this.transaction.id = this.transactionId;
    }
    else
      this.edit = true;

    this.$nextTick(() => this.dirty = false);
    this.refresh();
  },

	methods: {
    maxQuantity(quantity) {
      if (this.transactionId)
        return true;
      if (!quantity)
        return true;
      quantity = quantity.replace(/,/g, '');
      if (quantity <= 0)
        return 'Must be > 0';
      if (quantity > this.item.onHandQuantity && !this.item.allowNegativeInventory)
        return 'Must be <= ' + this.item.onHandQuantity;
      return true;
    },
    async refresh() {
      const results = await this.$apiCall(`query InventoryItemsTransferSite($id:ID!, $date:DateTime!) {
                                                item(id:$id) {
                                                  id,name,active,allowNegativeInventory,trackUnits,precision,lotTracking,pictureURL
                                                  sites(asof:$date) {siteId,lot,quantity}
                                                }
                                              }`,
                                          {id:this.transaction ? this.transaction.itemId : this.itemId,
                                          date:this.transaction.date});
      if (!results.error) {
        this.item = results.data.item;
        this.$nextTick(() => {
          this.$refs.form.validate();
        })
      }
    },
    cancel() {
      this.$router.back();
    },
		async save() {
      if (this.valid) {
        this.saving = true;
        const results = await this.$apiCall(`mutation InventoryItemsTransferSite($input: ItemTransferSiteInput!) {
                                              itemTransferSiteCreate(input:$input) {id}
                                            }`,
                                            {input:this.transaction});
        this.saving = false;
        if (!results.error) {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`${this.transactionId?'Updated':'Created'} move to site transaction for item ${this.item.name}`});
        }
      }
		}
	}
}
</script>